import ViewComfyOutlinedIcon from '@mui/icons-material/ViewComfyOutlined';
import CalendarViewMonthOutlinedIcon from '@mui/icons-material/CalendarViewMonthOutlined';
import { Button } from '@mui/material';

const TableViewModeToggleButton = ({ id, isExpandedApiRequestPerInsurers, setIsxpandedApiRequestPerInsurers, sx, addToPendingTasks }) => {
  
  function toggleTableView() {
    setIsxpandedApiRequestPerInsurers({ ...isExpandedApiRequestPerInsurers, [id]: !isExpandedApiRequestPerInsurers[id]  });

    addToPendingTasks([id]);
  }
  
  return (
    <Button
      sx={sx}
      endIcon={isExpandedApiRequestPerInsurers[id] ? <ViewComfyOutlinedIcon /> : <CalendarViewMonthOutlinedIcon />}
      onClick={toggleTableView}
    >{ isExpandedApiRequestPerInsurers[id] ? 'Show Standard Table' : 'Show All Deductible Options' }</Button>
  );
};

export default TableViewModeToggleButton;